import { render, staticRenderFns } from "./Skokie.vue?vue&type=template&id=20cfd53b&scoped=true&"
import script from "./Skokie.vue?vue&type=script&lang=js&"
export * from "./Skokie.vue?vue&type=script&lang=js&"
import style0 from "./Skokie.vue?vue&type=style&index=0&id=20cfd53b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cfd53b",
  null
  
)

export default component.exports